export const STYLES_CONFIG = {
    button: {
        smallBorderRadius: {
            "&.ant-btn.ant-btn-lg": {
                borderRadius: "8px !important",
            },
        },
    },
}
